// extracted by mini-css-extract-plugin
export var legendIndicator = "_ba-1";
export var legendRight = "_ba-0";